import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconFeatures: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="features">
    <path
      fillRule="evenodd"
      d="M16.528 1.715a.6.6 0 0 0-1.056 0l-1.497 2.772H11a.6.6 0 0 0-.44 1.009l2.53 2.718-1.267 3.586a.6.6 0 0 0 .852.727L16 10.72l3.324 1.808a.6.6 0 0 0 .853-.727l-1.268-3.586 2.53-2.718a.6.6 0 0 0-.44-1.01h-2.974l-1.497-2.771ZM14.86 5.372 16 3.262l1.139 2.11a.6.6 0 0 0 .528.315h1.955l-1.84 1.976a.6.6 0 0 0-.126.608l.868 2.455-2.237-1.217a.6.6 0 0 0-.574 0l-2.237 1.217.867-2.455a.6.6 0 0 0-.126-.608l-1.839-1.976h1.955a.6.6 0 0 0 .528-.315Z"
      clipRule="evenodd"
    />
    <path d="M7 3.4A1.6 1.6 0 0 0 5.4 5v15A1.6 1.6 0 0 0 7 21.6h10a1.6 1.6 0 0 0 1.6-1.6v-6h-1.2v6a.4.4 0 0 1-.4.4H7a.4.4 0 0 1-.4-.4V5a.4.4 0 0 1 .4-.4h2V3.4H7Z" />
    <path d="M15.5 15.6H11v-1.2h4.5v1.2Zm-4.5 3h3v-1.2h-3v1.2Zm-1-3H8v-1.2h2v1.2Zm-2 3h2v-1.2H8v1.2Z" />
  </Icon>
);
